import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faColumns } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import { bindActionCreators } from '@reduxjs/toolkit';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import * as myParkdSettingsActions from 'features/settings/myParkdSettingsActions';
import { connect } from 'react-redux';
import { ReduxState } from 'types';
import { formatMessage } from 'i18n/CurrentLocale';
import { getMyParkdUserSettings } from 'features/settings/myParkdSettings';


export type TableColumnSettingsName =
    'parkingSessionsColumnSettings' |
    'parkingSessionsOffstreetColumnSettings' |
    'vehiclesTableColumnSettings' |
    'usersTableColumnSettings';

export type OptionalColumn = {
    accessorKey: string,
    displayNameId: string
}

export type ColumnVisibility = Record<string, boolean>;

export const ManageTableColumnsModal = (props: Props) => {
    const { tableSettingsName, optionalColumns } = props.modalData;
    const columnSettings: ColumnVisibility = props.myParkdUserSettings?.[tableSettingsName] ?? {};

    const onToggleColumnVisibility = (accessorKey: string) => {
        const newValue = !columnSettings[accessorKey];
        const updatedSettings = {
            ...columnSettings,
            [accessorKey]: newValue
        }
        props.updateMyParkdSetting(tableSettingsName, updatedSettings, props.userId);
    }

    return (
        <div className="info-modal panel radius-rectangle">
            <div className="panel-header">
                <h2 className="bold-title">
                    <FontAwesomeIcon icon={faColumns} />
                    <FormattedMessage id='MODAL_EDIT_SESSION_COLUMN_VISIBILITY_TITLE' />
                </h2>
                <button className="btn-close-modal" onClick={() => props.closeModal()} />
            </div>
            <div className="panel-content">
                <div className="modal-content align-left">
                    <table className='tbl-modal'>
                        <thead>
                            <tr>
                                <th><FormattedMessage id='MODAL_EDIT_SESSION_COLUMN_VISIBILITY_THEAD_NAME' /></th>
                                <th><FormattedMessage id='MODAL_EDIT_SESSION_COLUMN_VISIBILITY_THEAD_VISIBILITY' /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {optionalColumns?.map(({ accessorKey, displayNameId }) => (
                                <tr key={accessorKey} >
                                    <td>
                                        <label htmlFor={`checkbox-${accessorKey}`}>{formatMessage({ id: displayNameId })}</label>
                                    </td>
                                    <td>
                                        <input
                                            type='checkbox'
                                            id={`checkbox-${accessorKey}`}
                                            checked={columnSettings[accessorKey]}
                                            onChange={() => onToggleColumnVisibility(accessorKey)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <button className='btn-blue' onClick={() => props.closeModal()}>
                    <FormattedMessage id='GLOBAL_CLOSE' />
                </button>
            </div>
        </div>
    );
}


type OwnProps = {
    modalData: {
        tableSettingsName: TableColumnSettingsName,
        optionalColumns: OptionalColumn[]
    }
}
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = OwnProps & StateProps & DispatchProps;

/* istanbul ignore next */
function mapStateToProps(state: ReduxState) {
    return {
        myParkdUserSettings: getMyParkdUserSettings(state),
        userId: state.user?.user?.id!
    }
}

function mapDispatchToProps(dispatch: any) {
    return bindActionCreators({
        updateMyParkdSetting: myParkdSettingsActions.updateMyParkdSetting,
        closeModal: modalWindowActions.closeModal,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageTableColumnsModal);